module.exports = __webpack_public_path__ + "static/media/rental-matic.30776fe4.png";